export const SALE_ASSISTANT_TAB = 'sales-assistant'
export const SUMMARY_TAB = 'summary'
export const TRANSCRIPT_TAB = 'transcript'
